import { TriangleView } from "./TriangleView";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { PieceColor } from "../../../enums/PieceColor";
import { Texture } from "@pixi/core";
import { injectable } from "@launchtray/tsyringe-async";
import { GameUIResourcesPackage } from "../../../../preloader/resources/GameUIResourcesPackage";

@injectable()
export class TriangleViewFactory {
    public constructor(
        private readonly gameUIResourcePackage: GameUIResourcesPackage
    ) { }

    public createTriangleView(rotationStatus: TriangleRotationStatus, color: PieceColor): TriangleView {
        return new TriangleView(this.pickTexture(rotationStatus, color), this.gameUIResourcePackage, color, rotationStatus);
    }

    private pickTexture(rotationStatus: TriangleRotationStatus, color: PieceColor): Texture {
        switch (rotationStatus) {
            case TriangleRotationStatus.BOTTOM_LEFT:
                switch (color) {
                    case PieceColor.RED: return this.gameUIResourcePackage.assets_game_red_bottom_left_png;
                    case PieceColor.BLUE: return this.gameUIResourcePackage.assets_game_blue_bottom_left_png;
                    case PieceColor.PURPLE: return this.gameUIResourcePackage.assets_game_purple_bottom_left_png;
                    case PieceColor.YELLOW: return this.gameUIResourcePackage.assets_game_yellow_bottom_left_png;
                    case PieceColor.GREEN: return this.gameUIResourcePackage.assets_game_green_bottom_left_png;
                    case PieceColor.ORANGE: return this.gameUIResourcePackage.assets_game_orange_bottom_left_png;
                }
            case TriangleRotationStatus.BOTTOM_RIGHT:
                switch (color) {
                    case PieceColor.RED: return this.gameUIResourcePackage.assets_game_red_bottom_right_png;
                    case PieceColor.BLUE: return this.gameUIResourcePackage.assets_game_blue_bottom_right_png;
                    case PieceColor.PURPLE: return this.gameUIResourcePackage.assets_game_purple_bottom_right_png;
                    case PieceColor.YELLOW: return this.gameUIResourcePackage.assets_game_yellow_bottom_right_png;
                    case PieceColor.GREEN: return this.gameUIResourcePackage.assets_game_green_bottom_right_png;
                    case PieceColor.ORANGE: return this.gameUIResourcePackage.assets_game_orange_bottom_right_png;
                }
            case TriangleRotationStatus.TOP_LEFT:
                switch (color) {
                    case PieceColor.RED: return this.gameUIResourcePackage.assets_game_red_top_left_png;
                    case PieceColor.BLUE: return this.gameUIResourcePackage.assets_game_blue_top_left_png;
                    case PieceColor.PURPLE: return this.gameUIResourcePackage.assets_game_purple_top_left_png;
                    case PieceColor.YELLOW: return this.gameUIResourcePackage.assets_game_yellow_top_left_png;
                    case PieceColor.GREEN: return this.gameUIResourcePackage.assets_game_green_top_left_png;
                    case PieceColor.ORANGE: return this.gameUIResourcePackage.assets_game_orange_top_left_png;
                }
            case TriangleRotationStatus.TOP_RIGHT:
                switch (color) {
                    case PieceColor.RED: return this.gameUIResourcePackage.assets_game_red_top_right_png;
                    case PieceColor.BLUE: return this.gameUIResourcePackage.assets_game_blue_top_right_png;
                    case PieceColor.PURPLE: return this.gameUIResourcePackage.assets_game_purple_top_right_png;
                    case PieceColor.YELLOW: return this.gameUIResourcePackage.assets_game_yellow_top_right_png;
                    case PieceColor.GREEN: return this.gameUIResourcePackage.assets_game_green_top_right_png;
                    case PieceColor.ORANGE: return this.gameUIResourcePackage.assets_game_orange_top_right_png;
                }
        }
    }
}